import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=4f93fd18&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Admin.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Admin.vue?vue&type=style&index=1&id=4f93fd18&scoped=true&lang=css&")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4f93fd18",
  null
  ,true
)

export default component.exports